<template>
  <page-wrapper :title="pageWrapper.title" :has-pad="pageWrapper.hasPad">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="mt-3">รายการ Articles</h1>
          <articles-selector
              v-model="pinnedArticles"
              :disabled="disabled"
              class="input"
            ></articles-selector>
        </div>
      </div>
      <div class="row">
        <div class="col text-end padding-adjust">
          <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ArticlesSelector from "@/lib/components/ArticlesSelector/ArticlesSelector";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { transformArticlesResponseToListItem } from "../transform";

export default {
  components: {
    PageWrapper,
    ScButton,
    'articles-selector': ArticlesSelector
  },
  data() {
    const pageWrapper = {
      title: "Pinned Article",
      hasPad: false
    };
    const pinnedArticles = [];
    const disabled = false;

    return {
      pageWrapper,
      pinnedArticles,
      disabled
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      const pinnedResponse = await baanRueJaiClient.admin.articles.getPin('PINNED_ARTICLE');
      this.pinnedArticles = pinnedResponse.data.result.map((item) =>
        transformArticlesResponseToListItem(item)
      );
    },
    async handleClickSave() {
      try {
        const requestPinnedArticles = this.pinnedArticles.map(
          pinnedArticle => pinnedArticle.id
        );
        const params = {
          article_ids: requestPinnedArticles
        };
        await baanRueJaiClient.admin.articles.putPin("PINNED_ARTICLE", params);

        this.$message.success("บันทึกสำเร็จ");
      } catch (error) {
        this.$message.error("ไม่สามารถบันทึก ได้ กรุณาลองใหม่อีกครั้ง");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-adjust {
  padding: 20px;
}
</style>
